import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type CustomTagListOption from 'lumen/models/custom-tag-list-option';
import type CustomTagValue from 'lumen/models/custom-tag-value';

export type TagType = 'list' | 'text' | 'user';

export default class CustomTagDefinition extends Model {
  [Type] = 'custom-tag-definition' as const;

  @hasMany('custom-tag-list-option', { async: false, inverse: 'definition' })
  declare options: HasMany<CustomTagListOption>;

  @attr('string') declare name: string;
  @attr('boolean') declare readOnly: boolean;
  @attr('string') declare tagType: TagType;

  serializeValuesForPayload(
    values: CustomTagValue[],
  ): string | number[] | null {
    switch (this.tagType) {
      case 'text':
        return values[0]?.textValue ?? null;
      case 'list':
        return values
          .map((v) => (v.listOption?.id ? Number(v.listOption.id) : null))
          .filter((id): id is number => id !== null);
      case 'user':
        return values
          .map((v) => (v.user?.id ? Number(v.user.id) : null))
          .filter((id): id is number => id !== null);
      default:
        return this.tagType satisfies never;
    }
  }
}
